import { ThemeContext } from "@/theme/ThemeProvider";
import { useContext } from "react";

interface SubMenuDropDownIconProps {
  isActive: boolean;
  isDefault?: boolean;
}

export default function SubMenuDropDownIcon({ isActive, isDefault }: SubMenuDropDownIconProps) {
  const {  isDarkMode, toggleTheme, } = useContext(ThemeContext);
  const theme = isDarkMode ? 'dark' : 'light';
	const fillColor = theme === 'light' ? 'black' : 'white';

	return (
		<svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M6 4.6L10.6 -6.11959e-08L12 1.4L6 7.4L-6.11959e-08 1.4L1.4 -4.63341e-07L6 4.6Z"
				fill={isActive || isDefault ? fillColor : '#b7b7b7'}
			/>
		</svg>
	);
}
